import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { Avatar, Button, Divider, Input, Modal, Spin, Tooltip } from "antd";
import { SearchOutlined, TagFilled } from "@ant-design/icons";
import { Space, Table, Tag } from "antd";
import { CPUIcon, Error, LicenseLockKey, Tick, ViewDetailsIcon } from "icons";
import { getDatatableWidth } from "pages/history/listing/helpers";
import { Link } from "react-router-dom";
import { UseApiCallV2, useDebounce } from "hooks";
import { UseApiCallForOldDashboardData } from "hooks/use-api-call-for-old-dashboard";
import { useCurrentUserContext } from "providers";
import { CreateNewLicense } from "../index";

export const ComputersTable = ({ setOpenDetailModal }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [userSearch, setUserSearch] = useState("");
  const deboucedSearch = useDebounce(userSearch, 500);
  const { user } = useCurrentUserContext();
  const [openCreateLicenseModal, setOpenCreateLicenseModal] = useState(false);

  const columns = [
    {
      title: "No.",
      dataIndex: "key",
      key: "key",
      // render: (text, record, index) => {
      //   const globalIndex = ((currentPage || 1) - 1) * pageSize + index + 1;
      //   return index < 9 && currentPage === 1 ? `0${index + 1}` : globalIndex;
      //   // const globalIndex = ((currentPage || 1) - 1) * pageSize + index + 1;
      //   // return index < 9 && currentPage === 1 ? `0${index + 1}` : globalIndex;
      // },
      width: "3%",
      fixed: "left",
    },
    {
      title: "User Name",
      dataIndex: "username",
      key: "username",
      width: "12%",
      render: (text) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            flexShrink: "0",
          }}
        >
          <Avatar
            src="https://avatar.iran.liara.run/public/68"
            style={{ flexShrink: "0" }}
          ></Avatar>
          <span style={{ overflow: "hidden" }}>{text}</span>
        </div>
      ),
    },
    {
      title: "License ID",
      dataIndex: "systemName",
      key: "systemName",
      width: "12%",
      ellipsis: true,
      render: (text) => (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <CPUIcon />
          <Tooltip title={text}>
            <span
              style={{
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {text}
            </span>
          </Tooltip>
        </div>
      ),
    },
    {
      title: "Email Address",
      dataIndex: "emailAddress",
      key: "emailAddress",
      width: "14%",
      ellipsis: true,
    },
    {
      title: "Last Captured",
      dataIndex: "lastCaptured",
      key: "lastCaptured",
      width: "9%",
    },

    {
      title: "Last Session",
      dataIndex: "lastSession",
      key: "lastSession",
      width: "9%",
    },
    {
      title: "Subscription Status",
      dataIndex: "subscriptionStatus",
      key: "subscriptionStatus",
      width: "10%",
      render: (_, record) => {
        const isStatusActive = record.subscriptionStatus === "Active";
        const lightRed = "#F63E504D";
        const lightGreen = "#A8D3BF";
        const red = "#F63E50";
        const green = "#16A665";
        return (
          <Space size="middle">
            <Tag
              icon={isStatusActive ? <Tick /> : <Error />}
              color={isStatusActive ? lightGreen : lightRed}
              bordered={true}
              className={styles.tag}
              style={{
                color: isStatusActive ? green : red,
                border: `1px solid ${isStatusActive ? green : red}`,
              }}
            >
              {record.subscriptionStatus}
            </Tag>
          </Space>
        );
      },
    },

    {
      title: "Last Communicated",
      dataIndex: "lastCommunicated",
      key: "lastCommunicated",
      width: "10%",
    },
    {
      title: "Remote Access",
      dataIndex: "remoteAccess",
      key: "remoteAccess",
      width: "10%",
      render: (_, record) => (
        <Space size="middle">
          <Link to="#" style={{ textDecoration: "underline" }}>
            {record.remoteAccess}
          </Link>
        </Space>
      ),
    },

    {
      title: "Action",
      key: "action",
      width: "10%",
      render: (_, record) => (
        <Space size="middle">
          <button
            className={styles.viewDetailsBtn}
            onClick={() => setOpenDetailModal(true)}
          >
            <span>
              <ViewDetailsIcon />
            </span>{" "}
            View Details
          </button>
        </Space>
      ),
    },
  ];

  // const {
  //   data: studiosOverview,
  //   isLoading: studiosOverviewLoading,
  //   error: studiosOverviewError,
  // } = UseApiCallForOldDashboardData({
  //   url: "studio_overview",
  //   method: "POST",
  //   body: {
  //     body: "None",
  //   },
  // });
  const {
    data: studiosOverview,
    isLoading: studiosOverviewLoading,
    error: studiosOverviewError,
  } = UseApiCallForOldDashboardData({
    url: "internal/get/allStudioLicenses",
    method: "POST",
    body: {
      email: "raja.faizan@fenrispakistan.com",
      // email: user?.email,
    },
  });

  const [studioFinalData, setStudioFinalData] = useState([]);

  const totalData = studiosOverview?.map((item, index) => {
    return {
      key: index + 1,
      username: `${item?.firstName} ${item?.lastName}`,
      systemName: item?.studioID,
      emailAddress: item?.email,
      lastCaptured: item?.lastCapture,
      lastSession: item?.lastSession,
      subscriptionStatus: item?.isActive ? "Active" : "Expired",
      lastCommunicated: "",
      remoteAccess: "",
    };
  });
  useEffect(() => {
    const filteredData = totalData?.filter((item) =>
      item.username?.toLowerCase()?.includes(deboucedSearch)
    );
    setStudioFinalData(filteredData);
  }, [deboucedSearch]);

  useEffect(() => {
    setStudioFinalData(totalData);
  }, [studiosOverview]);

  const data = [
    {
      key: "1",
      username: "Alina Cristino",
      systemName: "Studiostation-001",
      emailAddress: "someone@example.com",
      lastCaptured: "3 days ago",
      lastSession: "03.03.25",
      subscriptionStatus: "Active",
      lastCommunicated: "03.03.25",
      remoteAccess: 9876452,
    },
    {
      key: "2",
      username: "Alina Cristino",
      systemName: "Studiostation-001",
      emailAddress: "someone@example.com",
      lastCaptured: "3 days ago",
      lastSession: "03.03.25",
      subscriptionStatus: "Active",
      lastCommunicated: "03.03.25",
      remoteAccess: "Add AnyDesk",
    },
    {
      key: "3",
      username: "Alina Cristino",
      systemName: "Studiostation-001",
      emailAddress: "someone@example.com",
      lastCaptured: "3 days ago",
      lastSession: "03.03.25",
      subscriptionStatus: "Active",
      lastCommunicated: "03.03.25",
      remoteAccess: 9876452,
    },
    {
      key: "4",
      username: "Alina Cristino",
      systemName: "Studiostation-001",
      emailAddress: "someone@example.com",
      lastCaptured: "3 days ago",
      lastSession: "03.03.25",
      subscriptionStatus: "Active",
      lastCommunicated: "03.03.25",
      remoteAccess: 9876452,
    },
    {
      key: "5",
      username: "Alina Cristino",
      systemName: "Studiostation-001",
      emailAddress: "someone@example.com",
      lastCaptured: "3 days ago",
      lastSession: "03.03.25",
      subscriptionStatus: "Active",
      lastCommunicated: "03.03.25",
      remoteAccess: 9876452,
    },
    {
      key: "6",
      username: "Alina Cristino",
      systemName: "Studiostation-001",
      emailAddress: "someone@example.com",
      lastCaptured: "3 days ago",
      lastSession: "03.03.25",
      subscriptionStatus: "Active",
      lastCommunicated: "03.03.25",
      remoteAccess: "Add AnyDesk",
    },
    {
      key: "7",
      username: "Alina Cristino",
      systemName: "Studiostation-001",
      emailAddress: "someone@example.com",
      lastCaptured: "3 days ago",
      lastSession: "03.03.25",
      subscriptionStatus: "Expired",
      lastCommunicated: "03.03.25",
      remoteAccess: "Add AnyDesk",
    },
    {
      key: "8",
      username: "Alina Cristino",
      systemName: "Studiostation-001",
      emailAddress: "someone@example.com",
      lastCaptured: "3 days ago",
      lastSession: "03.03.25",
      subscriptionStatus: "Expired",
      lastCommunicated: "03.03.25",
      remoteAccess: 9876452,
    },
    {
      key: "9",
      username: "Alina Cristino",
      systemName: "Studiostation-001",
      emailAddress: "someone@example.com",
      lastCaptured: "3 days ago",
      lastSession: "03.03.25",
      subscriptionStatus: "Active",
      lastCommunicated: "03.03.25",
      remoteAccess: 9876452,
    },
    {
      key: "10",
      username: "Alina Cristino",
      systemName: "Studiostation-001",
      emailAddress: "someone@example.com",
      lastCaptured: "3 days ago",
      lastSession: "03.03.25",
      subscriptionStatus: "Active",
      lastCommunicated: "03.03.25",
      remoteAccess: 9876452,
    },
    {
      key: "11",
      username: "Alina Cristino",
      systemName: "Studiostation-001",
      emailAddress: "someone@example.com",
      lastCaptured: "3 days ago",
      lastSession: "03.03.25",
      subscriptionStatus: "Active",
      lastCommunicated: "03.03.25",
      remoteAccess: 9876452,
    },
    {
      key: "12",
      username: "Alina Cristino",
      systemName: "Studiostation-001",
      emailAddress: "someone@example.com",
      lastCaptured: "3 days ago",
      lastSession: "03.03.25",
      subscriptionStatus: "Active",
      lastCommunicated: "03.03.25",
      remoteAccess: 9876452,
    },
    {
      key: "13",
      username: "Alina Cristino",
      systemName: "Studiostation-001",
      emailAddress: "someone@example.com",
      lastCaptured: "3 days ago",
      lastSession: "03.03.25",
      subscriptionStatus: "Active",
      lastCommunicated: "03.03.25",
      remoteAccess: 9876452,
    },
  ];

  function handleChatSearch(e) {
    const searchedKey = e.target?.value?.toLowerCase();
    const filteredData = totalData.filter((item) =>
      item.username.toLowerCase().includes(searchedKey)
    );
    setStudioFinalData(filteredData);
  }

  function openCreateLicense() {
    setOpenCreateLicenseModal(true);
  }
  function handleCancel() {
    setOpenCreateLicenseModal(false);
  }
  return (
    <div className={styles.tableContainer}>
      <Spin spinning={studiosOverviewLoading}>
        <div className={styles.searchContainer}>
          <div className={styles.textContainer}>
            <h3>All Computers Overview</h3>
            <div>
              A comprehensive view of the status and activity of all computers
              in the system.
            </div>
          </div>
          <div className={styles.messageSearch}>
            <Input
              placeholder="Search"
              onChange={(e) => setUserSearch(e.target.value)}
              prefix={<SearchOutlined />}
              // value={filterInput}
            />
            <div
              className={styles.createLicenseBtn}
              onClick={openCreateLicense}
            >
              <LicenseLockKey />
              <div>Create License</div>
            </div>
          </div>
        </div>
        <Table
          columns={columns}
          dataSource={studioFinalData}
          rowClassName={styles.row}
          scroll={{
            y:
              window.innerWidth > 1600
                ? `calc(80dvh - 255px)`
                : `calc(71dvh - 230px)`,
            x: getDatatableWidth(),
          }} // Set the width for horizontal scrolling
          style={{ width: "100%" }}
          className={styles.table}
          sticky={true}
          pagination={{
            position: ["bottomCenter"],
            // pageSize: pageSize,
            // current: currentPage,
          }}
        />
      </Spin>
      <Modal
        open={openCreateLicenseModal}
        onCancel={handleCancel}
        footer={null}
        width={"46dvw"}
        destroyOnClose={true}
        className={styles.createLicenseModal}
        centered
        title="Create New License"
        styles={{
          header: {
            padding: "20px 20px 0 20px",
          },
        }}
      >
        <CreateNewLicense handleCloseModal={handleCancel} />
      </Modal>
    </div>
  );
};
